<div class="playlist-widget">
  <app-html5audio *ngFor="let song of songs" [song]="song"></app-html5audio>
</div>
